import { render, staticRenderFns } from "./CreateNewApplication.vue?vue&type=template&id=f0dfbf2e&scoped=true"
import script from "./CreateNewApplication.vue?vue&type=script&lang=js"
export * from "./CreateNewApplication.vue?vue&type=script&lang=js"
import style0 from "./CreateNewApplication.vue?vue&type=style&index=0&id=f0dfbf2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dfbf2e",
  null
  
)

export default component.exports